import axios from 'axios';
import errorMessage from './errorMessage';
import {
  GET_TRIBUN_USER_REQUEST,
  GET_TRIBUN_USER_SUCCESS,
  GET_TRIBUN_USER_FAILURE,

  GET_NICKNAME_CHANGE_REQUEST,
  GET_NICKNAME_CHANGE_SUCCESS,
  GET_NICKNAME_CHANGE_FAILURE,

  CREATE_TRIBUN_USER_REQUEST,
  CREATE_TRIBUN_USER_SUCCESS,
  CREATE_TRIBUN_USER_FAILURE,

  GET_ALL_TRIBUN_COUPONS_REQUEST,
  GET_ALL_TRIBUN_COUPONS_SUCCESS,
  GET_ALL_TRIBUN_COUPONS_FAILURE,

  FOLLOW_TRIBUN_USER_REQUEST,
  FOLLOW_TRIBUN_USER_SUCCESS,
  FOLLOW_TRIBUN_USER_FAILURE,

  MUTE_TRIBUN_USER_REQUEST,
  MUTE_TRIBUN_USER_SUCCESS,
  MUTE_TRIBUN_USER_FAILURE,

  UNFOLLOW_WATCHING_TRIBUN_USER_REQUEST,
  UNFOLLOW_WATCHING_TRIBUN_USER_SUCCESS,
  UNFOLLOW_WATCHING_TRIBUN_USER_FAILURE,

  LIKE_OR_UNLIKE_COUPON_REQUEST,
  LIKE_OR_UNLIKE_COUPON_SUCCESS,
  LIKE_OR_UNLIKE_COUPON_FAILURE,

  LIKE_OR_UNLIKE_COMMENT_REQUEST,
  LIKE_OR_UNLIKE_COMMENT_SUCCESS,
  LIKE_OR_UNLIKE_COMMENT_FAILURE,

  GET_TRIBUN_COUPON_DETAILS_REQUEST,
  GET_TRIBUN_COUPON_DETAILS_SUCCESS,
  GET_TRIBUN_COUPON_DETAILS_FAILURE,
  RESET_TRIBUN_COUPON_DETAILS,
  SAVE_UNEVALUATED_EVENTS,
  RESET_UNEVALUATED_EVENTS,

  GET_POPULAR_TRIBUN_USERS_REQUEST,
  GET_POPULAR_TRIBUN_USERS_SUCCESS,
  GET_POPULAR_TRIBUN_USERS_FAILURE,

  GET_FOLLOWING_TRIBUN_USERS_REQUEST,
  GET_FOLLOWING_TRIBUN_USERS_SUCCESS,
  GET_FOLLOWING_TRIBUN_USERS_FAILURE,

  GET_WINNER_TRIBUN_USERS_REQUEST,
  GET_WINNER_TRIBUN_USERS_SUCCESS,
  GET_WINNER_TRIBUN_USERS_FAILURE,

  SHARE_TRIBUN_COUPON_REQUEST,
  SHARE_TRIBUN_COUPON_SUCCESS,
  SHARE_TRIBUN_COUPON_FAILURE,


  POST_TRIBUN_SEARCH_REQUEST,
  POST_TRIBUN_SEARCH_SUCCESS,
  POST_TRIBUN_SEARCH_FAILURE,

  POST_TRIBUN_MENTION_SEARCH_REQUEST,
  POST_TRIBUN_MENTION_SEARCH_SUCCESS,
  POST_TRIBUN_MENTION_SEARCH_FAILURE,

  SHOW_OR_HIDE_COUOPON_REQUEST,
  SHOW_OR_HIDE_COUOPON_SUCCESS,
  SHOW_OR_HIDE_COUOPON_FAILURE,

  COMPLAINT_TRIBUN_REQUEST,
  COMPLAINT_TRIBUN_SUCCESS,
  COMPLAINT_TRIBUN_FAILURE,

  VERIFY_TRIBUN_REQUEST,
  VERIFY_TRIBUN_SUCCESS,
  VERIFY_TRIBUN_FAILURE,

  RESET_SEARCH_AREA,
  RESET_SEARCH_MATCH,
  RESET_TRIBUN_TAB,
  GET_CONTINUED_COUPONS_SUCCESS,
  GET_OUT_RIGHT_CONTINUE_COUPONS_SUCCESS,

  SEARCH_PREDICTIONS_REQUEST,
  SEARCH_PREDICTIONS_SUCCESS,
  SEARCH_PREDICTIONS_FAILURE,

  GET_SEARCHED_EVENT_COUPON_REQUEST,
  GET_SEARCHED_EVENT_COUPON_SUCCESS,
  GET_SEARCHED_EVENT_COUPON_FAILURE,

  SEND_COMMENT_REQUEST,
  SEND_COMMENT_SUCCESS,
  SEND_COMMENT_FAILURE,
  SEND_COMMENT_LIMIT_FAILURE,

  GET_COMMENT_REQUEST,
  GET_COMMENT_SUCCESS,
  GET_COMMENT_FAILURE,
  GET_COMMENT_LIST_SUCCESS,
  RESET_COMMENT_LIST,

  DELETE_COMMENT_REQUEST,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILURE,

  BLOCK_USER_REQUEST,
  BLOCK_USER_SUCCESS,
  BLOCK_USER_FAILURE,

  UNBLOCK_USER_REQUEST,
  UNBLOCK_USER_SUCCESS,
  UNBLOCK_USER_FAILURE,

  BLOCK_ANOTHER_USER_REQUEST,
  BLOCK_ANOTHER_USER_SUCCESS,
  BLOCK_ANOTHER_USER_FAILURE,

  UNBLOCK_ANOTHER_USER_REQUEST,
  UNBLOCK_ANOTHER_USER_SUCCESS,
  UNBLOCK_ANOTHER_USER_FAILURE,

  COMMENT_FORBID_ALLOW_REQUEST,
  COMMENT_FORBID_ALLOW_SUCCESS,
  COMMENT_FORBID_ALLOW_FAILURE,

  GET_EVENT_STATUS_UPDATE_SUCCESS,
  EVENT_SCORES_SUCCESS,

  GET_TRIBUN_USER_AGREEMENT_REQUEST,
  GET_TRIBUN_USER_AGREEMENT_SUCCESS,
  GET_TRIBUN_USER_AGREEMENT_FAILURE,

  GET_TRIBUN_TERM_OF_USE_REQUEST,
  GET_TRIBUN_TERM_OF_USE_SUCCESS,
  GET_TRIBUN_TERM_OF_USE_FAILURE,

  GET_LEADER_TRIBUN_USERS_REQUEST,
  GET_LEADER_TRIBUN_USERS_SUCCESS,
  GET_LEADER_TRIBUN_USERS_FAILURE,

  GET_TRIBUN_SPACE_COUPONS_REQUEST,
  GET_TRIBUN_SPACE_COUPONS_SUCCESS,
  GET_TRIBUN_SPACE_COUPONS_FAILURE,

  UPDATE_TRIBUN_COUPON_NAME_REQUEST,
  UPDATE_TRIBUN_COUPON_NAME_SUCCESS,
  UPDATE_TRIBUN_COUPON_NAME_FAILURE,

  DELETE_TRIBUN_COUPON_NAME_REQUEST,
  DELETE_TRIBUN_COUPON_NAME_SUCCESS,
  DELETE_TRIBUN_COUPON_NAME_FAILURE,

  HIDE_TRIBUN_FEED_COUPON_REQUEST,
  HIDE_TRIBUN_FEED_COUPON_SUCCESS,
  HIDE_TRIBUN_FEED_COUPON_FAILURE,

  GET_FILTERS_SORTING_REQUEST,
  GET_FILTERS_SORTING_SUCCESS,
  GET_FILTERS_SORTING_FAILURE,

  SPACE_COUPON_MIX_PANEL,

  TRIBUN_FILTER_SORT_OPTIONS
} from 'Store/constants';
import { openModal, closeModal, getEventScores, getEventStatusUpdate, getTribunAnotherUser } from 'Store/actions';
import clone from 'lodash/clone';
import LocalStorage from 'Utils/localStorage';
import EnvironmentManager from 'Utils/environmentManager';
import {
  trackCommentTribunCoupon,
  trackLikeTribunCoupon,
  trackDeleteTribunComment,
  trackFollowTribunUser,
  trackTribunFollowUser,
  trackShareTribunCoupon
} from 'Utils/analytics';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;
import { replaceUrlWithPublicUrl } from 'Utils/replaceUrlWithPublicUrl';
import { tribunShare } from 'Utils/dengageEvents';
import mixpanel from 'Utils/mixpanel';

const tribunFeedsRequestData = {
  max: 500000,
  sortField: 'date',
  sortOrder: 'DESC',
  coupon: 'all',
  count: 30,
  channel: 'WEB',
  filterCount: '0',
  canBet: true,
  resultToday: false,
  category: 'both',
  min: 1,
  longTerm: false,
  sportType: '0'
};

const searchedEvent = {
  canBet: true,
  category: 'both', //yalnızca football ve basketball eventlerini kapsıyor.
  count: 30,
  coupon: 'all',
  filterCount: '0',
  longTerm: true,
  max: 5000,
  min: 1,
  resultToday: false,
  sortField: 'date',
  sortOrder: 'DESC'
};

const { FILTER_V2 } = TRIBUN_FILTER_SORT_OPTIONS;

export const getUserTribunToken = (origin, couponId, couponDetail) => async dispatch => {
  try {
    /*dispatch({
      type: GET_USER_TRIBUN_TOKEN_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/v2/mobile/tribun/create/token`, { headers: { channel: 0 } });

    LocalStorage.set('tribunUserToken', res.data.token);

    dispatch({
      type: GET_USER_TRIBUN_TOKEN_SUCCESS,
      payload: res.data
    });*/

    await dispatch(getTribunUser(origin, couponId, couponDetail));

  } catch (e) {
    //console.log(e);

    /*dispatch({
      type: GET_USER_TRIBUN_TOKEN_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });*/
  }
};

export const getTribunUser = (origin, coupon, couponDetail) => async dispatch => {
  dispatch({
    type: GET_TRIBUN_USER_REQUEST
  });

  try {
    const res = await axios.get(`${API_GATEWAY}/v2/mobile/tribun/user`, { headers: { channel: '0' } });

    LocalStorage.set('tribunUser', res.data.tribunUser);

    const { tribunUser } = res.data;

    if (tribunUser.status === 'NEW') {
      switch (origin) {
        case 'betSlip':
          dispatch(closeModal('couponSuccesShareOnTribun'));
          dispatch(openModal('tribunBetslipLoginSuccessModal', { userName: tribunUser.originalNickName, userId: tribunUser.userId, coupon: coupon, couponDetail: couponDetail }));
          break;
        case 'home':
          dispatch(openModal('tribunHomeLoginSuccessModal', { userName: tribunUser.originalNickName, userId: tribunUser.userId }));
          break;
        case 'coupons':
          dispatch(closeModal('couponSuccesShareOnTribun'));
          dispatch(closeModal('shareOnTribunModal'));
          dispatch(openModal('tribunCouponsLoginSuccessModal', { userName: tribunUser.originalNickName, userId: tribunUser.userId, coupon: coupon }));
          dispatch(openModal('couponSuccessLoginSuccessModal', { userName: tribunUser.originalNickName, userId: tribunUser.userId, coupon: coupon }));
          break;
        case 'tribun':
          dispatch(openModal('tribunLoginSuccessModal', { userName: tribunUser.originalNickName, userId: tribunUser.userId }));
          break;
      }
    } else if (tribunUser.status === 'FORCED_NICKNAME') {
      await dispatch(nicknameChange());
    }

    dispatch({
      type: GET_TRIBUN_USER_SUCCESS,
      payload: tribunUser
    });
  } catch (e) {
    dispatch({
      type: GET_TRIBUN_USER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });

  }
};

export const nicknameChange = token => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_NICKNAME_CHANGE_REQUEST
    });

    const channel = 0;
    await axios.get(`${API_GATEWAY}/v2/mobile/tribun/read/nicknameChange`, { headers: { channel } }).then(res => {

      dispatch({
        type: GET_NICKNAME_CHANGE_SUCCESS,
        payload: res.data
      });
    });

    LocalStorage.set('tribunNicknameChange', true);

  } catch (e) {

    dispatch({
      type: GET_NICKNAME_CHANGE_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const createTribunUser = (userId, routeName, coupon) => async (dispatch, getState) => {

  const body = {
    channel: '0'
  };

  dispatch({
    type: CREATE_TRIBUN_USER_REQUEST
  });

  try {
    const res = await axios.post(`${API_GATEWAY}/v2/mobile/tribun/create/user`, body);

    dispatch({
      type: CREATE_TRIBUN_USER_SUCCESS,
      payload: res.data
    });
    LocalStorage.set('tribunUser', res.data.tribunUser);

    if (routeName === 'coupons') {
      dispatch(shareTribunCoupon(coupon, 'coupons'));
    }

    if (routeName === 'betSlip') {
      dispatch(shareTribunCoupon(coupon, 'betSlip'));
    }

    return res.data;
  } catch (e) {
    dispatch({
      type: CREATE_TRIBUN_USER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });

    return null;
  }
};

export const getAllTribunCoupons = offset => async (dispatch, getState) => {
  try {
    const requestBody = clone(tribunFeedsRequestData);
    const user = getState().auth.data;
    let appliedFilters;

    if (LocalStorage.get('tribunHeaderSortOptions') && LocalStorage.get('tribunHeaderSortOptions').all) {
      requestBody.sortField = LocalStorage.get('tribunHeaderSortOptions').all.sortField;
      requestBody.sortOrder = LocalStorage.get('tribunHeaderSortOptions').all.sortOrder;
    }

    const storedFilters = LocalStorage.get(FILTER_V2.appliedFiltersLocalStorageKey);
    if (storedFilters && storedFilters.all) {
      appliedFilters = storedFilters.all;
    } else {
      appliedFilters = FILTER_V2.defaultSelectedFilters;
    }
    Object.keys(appliedFilters).forEach(key => {
      requestBody[key] = appliedFilters[key];
    });

    if (offset) {
      requestBody.offset = offset;
    }

    dispatch({
      type: GET_ALL_TRIBUN_COUPONS_REQUEST
    });

    const res = await axios.post(replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/feed/all`),
      requestBody,
      {
        headers: {
          channel: '0'
        }
      });


    if (!res.data.feeds.length) {
      return dispatch({
        type: GET_ALL_TRIBUN_COUPONS_FAILURE,
        lastPage: true
      });
    }

    dispatch({
      type: GET_ALL_TRIBUN_COUPONS_SUCCESS,
      payload: res.data.feeds,
      lastPage: res.data.lastPage
    });

  } catch (e) {
    dispatch({
      type: GET_ALL_TRIBUN_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
      lastPage: true
    });
  }
};

export const getSpaceCoupon = (type, dateRange) => async (dispatch, getState) => {
  try {
    const tribunFeedsRequestData = {
      count: 10,
      type: type.toUpperCase(),
      dateRange: dateRange.toUpperCase()
    };

    const requestBody = clone(tribunFeedsRequestData);
    const user = getState().auth.data;

    dispatch({
      type: GET_TRIBUN_SPACE_COUPONS_REQUEST
    });

    const res = await axios.post(replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/feed/space`),
      requestBody,
      {
        headers: {
          channel: '0'
        }
      });

    if (!res.data.feeds.length) {
      return dispatch({
        type: GET_TRIBUN_SPACE_COUPONS_FAILURE,
        lastPage: true
      });
    }

    dispatch({
      type: GET_TRIBUN_SPACE_COUPONS_SUCCESS,
      payload: res.data.feeds,
      lastPage: res.data.lastPage
    });

  } catch (e) {
    console.log(e);

    dispatch({
      type: GET_TRIBUN_SPACE_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
      lastPage: true
    });
  }
};

export const getLeaderTribunUsers = offset => async (dispatch, getState) => {
  try {
    const requestBody = clone(tribunFeedsRequestData);
    const user = getState().auth.data;
    let appliedFilters;

    if (offset) {
      requestBody.offset = offset;
    }

    if (LocalStorage.get('tribunHeaderSortOptions') && LocalStorage.get('tribunHeaderSortOptions').leader) {
      requestBody.sortField = LocalStorage.get('tribunHeaderSortOptions').leader.sortField;
      requestBody.sortOrder = LocalStorage.get('tribunHeaderSortOptions').leader.sortOrder;
    }

    const storedFilters = LocalStorage.get(FILTER_V2.appliedFiltersLocalStorageKey);
    if (storedFilters && storedFilters.leader) {
      appliedFilters = storedFilters.leader;
    } else {
      appliedFilters = FILTER_V2.defaultSelectedFilters;
    }
    Object.keys(appliedFilters).forEach(key => {
      requestBody[key] = appliedFilters[key];
    });

    dispatch({
      type: GET_LEADER_TRIBUN_USERS_REQUEST
    });

    const res = await axios.post(replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/feed/topHundred`),
      requestBody,
      {
        headers: {
          channel: '0'
        }
      });

    if (!res.data.feeds.length) {
      return dispatch({
        type: GET_LEADER_TRIBUN_USERS_FAILURE,
        lastPage: true
      });
    }

    dispatch({
      type: GET_LEADER_TRIBUN_USERS_SUCCESS,
      payload: res.data.feeds,
      lastPage: res.data.lastPage
    });

  } catch (e) {
    dispatch({
      type: GET_LEADER_TRIBUN_USERS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
      lastPage: true
    });
  }
};

export const getPopularTribunUsers = offset => async (dispatch, getState) => {
  try {
    const requestBody = clone(tribunFeedsRequestData);
    const user = getState().auth.data;

    if (offset) {
      requestBody.offset = offset;
    }

    if (LocalStorage.get('tribunHeaderSortOptions') && LocalStorage.get('tribunHeaderSortOptions').popular) {
      requestBody.sortField = LocalStorage.get('tribunHeaderSortOptions').popular.sortField;
      requestBody.sortOrder = LocalStorage.get('tribunHeaderSortOptions').popular.sortOrder;
    }

    if (LocalStorage.get('tribunHeaderFilterOptions') && LocalStorage.get('tribunHeaderFilterOptions').popular) {
      requestBody.coupon = LocalStorage.get('tribunHeaderFilterOptions').popular.coupon;
    }

    dispatch({
      type: GET_POPULAR_TRIBUN_USERS_REQUEST
    });

    const res = await axios.post(replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/feed/popular`),
      requestBody,
      {
        headers: {
          channel: '0'
        }
      });

    if (!res.data.feeds.length) {
      return dispatch({
        type: GET_POPULAR_TRIBUN_USERS_FAILURE,
        lastPage: true
      });
    }

    dispatch({
      type: GET_POPULAR_TRIBUN_USERS_SUCCESS,
      payload: res.data.feeds,
      lastPage: res.data.lastPage
    });

  } catch (e) {

    dispatch({
      type: GET_POPULAR_TRIBUN_USERS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
      lastPage: true
    });
  }
};

export const getFollowingTribunUsers = offset => async (dispatch, getState) => {
  try {
    const requestBody = clone(tribunFeedsRequestData);
    const user = getState().auth.data;
    let appliedFilters;

    if (offset) {
      requestBody.offset = offset;
    }

    if (LocalStorage.get('tribunHeaderSortOptions') && LocalStorage.get('tribunHeaderSortOptions').following) {
      requestBody.sortField = LocalStorage.get('tribunHeaderSortOptions').following.sortField;
      requestBody.sortOrder = LocalStorage.get('tribunHeaderSortOptions').following.sortOrder;
    }

    const storedFilters = LocalStorage.get(FILTER_V2.appliedFiltersLocalStorageKey);
    if (storedFilters && storedFilters.following) {
      appliedFilters = storedFilters.following;
    } else {
      appliedFilters = FILTER_V2.defaultSelectedFilters;
    }
    Object.keys(appliedFilters).forEach(key => {
      requestBody[key] = appliedFilters[key];
    });

    dispatch({
      type: GET_FOLLOWING_TRIBUN_USERS_REQUEST
    });

    const res = await axios.post(replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/feed/following`),
      requestBody,
      {
        headers: {
          channel: '0'
        }
      });

    if (!res.data.feeds.length) {
      return dispatch({
        type: GET_FOLLOWING_TRIBUN_USERS_FAILURE,
        lastPage: true
      });
    }

    dispatch({
      type: GET_FOLLOWING_TRIBUN_USERS_SUCCESS,
      payload: res.data.feeds,
      lastPage: res.data.lastPage
    });

  } catch (e) {
    dispatch({
      type: GET_FOLLOWING_TRIBUN_USERS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
      lastPage: true
    });
  }
};

export const getWinnerTribunUsers =  offset => async (dispatch, getState) => {
  try {
    const requestBody = clone(tribunFeedsRequestData);
    const user = getState().auth.data;
    let appliedFilters;

    if (offset) {
      requestBody.offset = offset;
    }

    const storedFilters = LocalStorage.get(FILTER_V2.appliedFiltersLocalStorageKey);
    if (storedFilters && storedFilters.won) {
      appliedFilters = storedFilters.won;
    } else {
      appliedFilters = FILTER_V2.defaultSelectedFilters;
    }
    Object.keys(appliedFilters).forEach(key => {
      requestBody[key] = appliedFilters[key];
    });

    if (LocalStorage.get('tribunHeaderSortOptions') && LocalStorage.get('tribunHeaderSortOptions').won) {
      requestBody.sortField = LocalStorage.get('tribunHeaderSortOptions').won.sortField;
      requestBody.sortOrder = LocalStorage.get('tribunHeaderSortOptions').won.sortOrder;
    } else {
      requestBody.sortField = 'date';
      requestBody.sortOrder = 'DESC';
    }

    if (LocalStorage.get('tribunHeaderSortOptions') && LocalStorage.get('tribunHeaderSortOptions').won && LocalStorage.get('tribunHeaderSortOptions').won?.sortField === 'odd') {
      requestBody.sortField = 'winningOdd';
    }

    dispatch({
      type: GET_WINNER_TRIBUN_USERS_REQUEST
    });

    const res = await axios.post(replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/feed/won`),
      requestBody,
      {
        headers: {
          channel: '0'
        }
      });

    if (!res.data.feeds.length) {
      return dispatch({
        type: GET_WINNER_TRIBUN_USERS_FAILURE,
        lastPage: true
      });
    }

    dispatch({
      type: GET_WINNER_TRIBUN_USERS_SUCCESS,
      payload: res.data.feeds,
      lastPage: res.data.lastPage
    });

  } catch (e) {

    dispatch({
      type: GET_WINNER_TRIBUN_USERS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
      lastPage: true
    });
  }
};

export const followTribunUser = (follow, userId, tabType, username) => async (dispatch, getState) => {
  try {
    dispatch({
      type: FOLLOW_TRIBUN_USER_REQUEST
    });


    const res = await axios.get(`${API_GATEWAY}/v2/mobile/tribun/followuser?follow=${follow}&userid=${userId}`, { headers: { channel: '0' } });

    if (follow === false && tabType === 'profile') {
      dispatch(getTribunAnotherUser(userId));
    }

    if (follow === false && tabType !== 'profile') {
      if (tabType === 'following') {
        dispatch(resetTribunTab());
      }
      dispatch(getFollowingTribunUsers());
    }

    dispatch({
      type: FOLLOW_TRIBUN_USER_SUCCESS,
      payload: res.data,
      userId: userId,
      tabType: tabType,
      follow: follow,
      username: username
    });

    if (follow) {
      trackFollowTribunUser();
      trackTribunFollowUser();
    }

  } catch (e) {
    dispatch({
      type: FOLLOW_TRIBUN_USER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const muteTribunUser = (userId, tabType, username) => async (dispatch, getState) => {
  try {
    dispatch({
      type: MUTE_TRIBUN_USER_REQUEST
    });

    const res = await axios.post(`${API_GATEWAY}/v2/mobile/tribun/user/mutes?mutedUserId=${userId}`, {}, { headers: { channel: '0' } });

    dispatch({
      type: MUTE_TRIBUN_USER_SUCCESS,
      payload: res.data,
      userId: userId,
      tabType: tabType,
      username: username
    });

    if (tabType === 'profile') {
      dispatch(getTribunAnotherUser(userId));
    } else {
      dispatch(resetTribunTab());

      if (tabType === 'all') {
        dispatch(getAllTribunCoupons());
      } else if (tabType === 'leader') {
        dispatch(getLeaderTribunUsers());
      } else if (tabType === 'following') {
        dispatch(getFollowingTribunUsers());
      } else if (tabType === 'won') {
        dispatch(getWinnerTribunUsers());
      }
    }

  } catch (e) {
    dispatch({
      type: MUTE_TRIBUN_USER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
    throw e;
  }
};

export const unMuteTribunUser = (userId, tabType, username) => async dispatch => {
  try {
    dispatch({
      type: MUTE_TRIBUN_USER_REQUEST
    });

    const res = await axios.delete(`${API_GATEWAY}/v2/mobile/tribun/user/mutes?mutedUserId=${userId}`, { headers: { channel: '0' } });

    dispatch({
      type: MUTE_TRIBUN_USER_SUCCESS,
      payload: res.data,
      userId: userId,
      tabType: tabType,
      username: username,
      isUnmute: true
    });

    if (tabType === 'profile') {
      dispatch(getTribunAnotherUser(userId));
    }

  } catch (e) {
    dispatch({
      type: MUTE_TRIBUN_USER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
    throw e;
  }
};

export const unFollowWatch = userId => async dispatch =>  {

  try {
    dispatch({
      type: UNFOLLOW_WATCHING_TRIBUN_USER_REQUEST
    });

    const resUnfollowPush = await axios.get(`${API_GATEWAY}/v2/mobile/tribun/push/unfollow?userid=${userId}`, { headers: { channel: '0' } });

    dispatch({
      type: UNFOLLOW_WATCHING_TRIBUN_USER_SUCCESS,
      payload: resUnfollowPush.data,
      userId: userId,
    });

  } catch (e) {
    dispatch({
      type: UNFOLLOW_WATCHING_TRIBUN_USER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const likeOrUnlikeCoupon = (feedId, like, likes, tabType, coupon, username) => async (dispatch, getState) => {

  dispatch({
    type: LIKE_OR_UNLIKE_COUPON_REQUEST
  });

  axios.get(`${API_GATEWAY}/v2/mobile/tribun/feed/likeunlike?feedid=${feedId}&like=${like}`, { headers: { channel: '0' } }).then(() => {

    dispatch({
      type: LIKE_OR_UNLIKE_COUPON_SUCCESS,
      feedId: feedId,
      status: status,
      likes: likes,
      tabType: tabType,
      isLiked: like,
      coupon,
      username
    });

    like && trackLikeTribunCoupon(feedId);

  }).catch(e => {
    dispatch({
      type: LIKE_OR_UNLIKE_COUPON_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  });
};

export const likeOrUnlikeComment = (feedId, commentId, likeType, likes) => async (dispatch, getState) => {

  dispatch({
    type: LIKE_OR_UNLIKE_COMMENT_REQUEST
  });

  axios.post(`${API_GATEWAY}/v2/mobile/tribun/comment/${commentId}/${likeType ? 'like' : 'unlike'}`, {
    channel: '0'
  }, { headers: { channel: '0' } }).then(() => {

    dispatch({
      type: LIKE_OR_UNLIKE_COMMENT_SUCCESS,
      commentId: commentId,
      feedId: feedId,
      likes: likes
    });
  }).catch(e => {
    dispatch({
      type: LIKE_OR_UNLIKE_COMMENT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  });
};

export const getTribunCouponDetails = (
  feedId = null,
  tribunSearchData = null,
  { fetchScores = true }, loginStatus = {}
) => async (dispatch, getState) => {
  let unevaluatedEvents = [];
  let hasStatusEvents = [];
  let hasOfficialScoresEvents = [];
  let unOfficialScoresEvents = { selections: [] };
  let hasLiveEvent = false;
  let couponStatus = 'created';
  let feeds = [];

  try {
    if (feedId) {
      dispatch({ type: GET_TRIBUN_COUPON_DETAILS_REQUEST });
      const user = getState().auth.data;
      const res = await axios.get(
        replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/feed/detail?feedid=${feedId}`),
        { headers: { channel: '0' } }
      );

      if (res?.data?.feeds?.length > 0) {
        feeds = [res.data.feeds[0]];
      }

      dispatch({
        type: GET_TRIBUN_COUPON_DETAILS_SUCCESS,
        payload: res.data.feeds[0]
      });
    } else if (tribunSearchData) {
      feeds = tribunSearchData;
    }

    feeds.forEach(feed => {
      const coupon = feed.coupon;

      if (!coupon || !coupon.selections?.length) return;

      const currentUnevaluatedEvents = processSelections(feedId ? coupon.selections : [coupon.selections[0]], coupon.status);

      if (((couponStatus === 'created' && hasLiveEvent) || couponStatus !== 'created') && unevaluatedEvents.length && loginStatus) {
        dispatch({
          type: SAVE_UNEVALUATED_EVENTS,
          payload: {
            feedId: feedId ? feedId : feed.feedId,
            unevaluatedEvents: currentUnevaluatedEvents
          }
        });
      }
    });

    if (hasStatusEvents.length) {
      dispatch({
        type: GET_EVENT_STATUS_UPDATE_SUCCESS,
        payload: hasStatusEvents.map(event => ({
          eventId: event.eventId,
          marketId: event?.marketId,
          outcomeNo: event.marketOutcomeNo,
          status: event.winningStatus,
          currentScoreDisplay: event.currentScoreDisplay
        }))
      });
    }

    if (((couponStatus === 'created' && hasLiveEvent) || couponStatus !== 'created') && unevaluatedEvents.length && loginStatus) {
      const allUnevaluatedEvents = unevaluatedEvents.flat();
      if (allUnevaluatedEvents.length) {
        dispatch(getEventStatusUpdate(allUnevaluatedEvents));
      }
    }

    if (hasOfficialScoresEvents.length) {
      dispatch({
        type: EVENT_SCORES_SUCCESS,
        payload: hasOfficialScoresEvents.map(event => ({
          currentScore: {
            home: event.officialResult.fullTime.home,
            away: event.officialResult.fullTime.away,
            type: 'FULL_TIME'
          },
          scores: event.officialResult.halfTime
            ? [{
              home: event.officialResult.halfTime.home,
              away: event.officialResult.halfTime.away,
              type: 'HALF_TIME',
              title: 'İY'
            }]
            : [],
          sbsEventId: event.eventId,
          matchStatus: 'Played'
        }))
      });
    }

    if (fetchScores && unOfficialScoresEvents.selections.length && loginStatus) {
      const selectedScores = feedId ? unOfficialScoresEvents : { selections: [unOfficialScoresEvents.selections[0]] };
      dispatch(getEventScores([selectedScores]));
    }
  } catch (error) {
    dispatch({
      type: GET_TRIBUN_COUPON_DETAILS_FAILURE,
      payload: error.response?.data || 'An error occurred while fetching data'
    });
  }

  function processSelections (selections, status) {
    const currentUnevaluatedEvents = [];
  
    selections.forEach(selection => {
      hasLiveEvent = hasLiveEvent || selection.isLive;
      couponStatus = status || 'created';

      if (selection.winningStatus === 'UNEVALUATED') {
        currentUnevaluatedEvents.push(selection);
        unevaluatedEvents.push(selection);
      } else {
        hasStatusEvents.push(selection);
      }

      if (!selection.officialResult) {
        unOfficialScoresEvents.selections.push(selection);
      } else {
        hasOfficialScoresEvents.push(selection);
      }
    });

    return currentUnevaluatedEvents;
  }
};

export const removeTribunDetailsFromInterval = (feedId, isHighlightOpen = false) => (dispatch, getState) => {
  if (feedId == null) {
    dispatch({ type: RESET_UNEVALUATED_EVENTS });
  } else {
    let unevaluatedEvents = null;

    if (isHighlightOpen) {
      const storedFeeds = getState().tribun.tribunCouponDetails.storedFeeds;

      const searchData = getState().tribun.tribunSearch.data;
      const matchCardFeeds = getState().matchCard.tribun.lastMatchCardFeeds;

      const matchedFeed = searchData?.find(f => f.feedId === feedId)
                 ?? matchCardFeeds?.find(f => f.feedId === feedId);

      const correctSelection = matchedFeed?.coupon?.selections?.[0];
      const allEvents = storedFeeds?.[feedId];
      
      if (correctSelection?.isLive && allEvents?.length) {
        unevaluatedEvents = allEvents.filter(e =>
          e.eventId === correctSelection.eventId
          && e.marketId === correctSelection.marketId
          && e.marketOutcomeNo === correctSelection.marketOutcomeNo
        );
      }
    }

    dispatch({
      type: SAVE_UNEVALUATED_EVENTS,
      payload: {
        feedId,
        unevaluatedEvents,
      }
    });
  }
};

export const getTribunCouponDetailsInterval = (intervalTime = Number(EnvironmentManager.getMessageText({ key: 'winning_losing_request_duration' }))) => (dispatch, getState) => {
  
  if (EnvironmentManager.getMessageText({ key: 'winning_losing_request_enable' })) {
    return setInterval(() => {
      const storedFeeds = getState().tribun.tribunCouponDetails.storedFeeds;
  
      if (storedFeeds && typeof storedFeeds === 'object') {
        const allUnevaluatedEvents = Object.values(storedFeeds).flat();
        dispatch(getEventStatusUpdate(allUnevaluatedEvents));
      }
    }, intervalTime);
  }
};

export const resetTribunCouponDetails = () => dispatch => {
  dispatch({
    type: RESET_TRIBUN_COUPON_DETAILS
  });
};

export const prepareShareTribunCoupon = couponId => async dispatch => {
  try {
    const res = await axios.get(`${API_GATEWAY}/v2/mobile/tribun/coupon/share/prepare?couponId=${couponId}`, { headers: { channel: '0' } });

    return res.data;
  } catch (e) {
    dispatch(openModal('couponSharePrepareFailedModal', e.response && e.response.data || errorMessage));

    return null;
  }
};

export const shareTribunCoupon = (coupon, origin, message, tabType) => async (dispatch, getState) => {

  if (origin === 'coupons') {
    await dispatch(verifyTribun(coupon, origin));
  } else {
    await dispatch(verifyTribun(coupon.coupon, origin));
  }

  if (!getState().tribun.tribunVerify.error) {
    const isLongTermCoupon = coupon?.coupon?.bets?.some(bet => bet?.outright);

    return new Promise(async (resolve, reject) => {

      dispatch({
        type: SHARE_TRIBUN_COUPON_REQUEST
      });

      axios.post(`${API_GATEWAY}/v2/mobile/tribun/coupon/share`, { couponId: coupon?.couponId || coupon?.coupon?.transactionId || coupon?.transactionId || coupon, message: message }, { headers: { channel: '0' } }).then(response => {

        dispatch({
          type: SHARE_TRIBUN_COUPON_SUCCESS,
          payload: response.data,
          coupon
        });

        if (origin === 'coupons') {
          mixpanel.track('Click Share Coupon on Coupon Share Sheet', {
            'Tactic Text': message || '-',
            'Character Count': message?.length || 0
          });
        }

        trackShareTribunCoupon();

        tribunShare({
          coupon_id: coupon?.couponId || coupon?.coupon?.transactionId || coupon,
          // eslint-disable-next-line no-nested-ternary
          share_source: origin === 'betSlip' ? 'from_popup' : origin === 'coupons' ?  'from_mybetslip' : 'undefined_share_source'
        });

        dispatch(closeModal('shareOnTribunModal'));
        dispatch(closeModal('couponSuccesShareOnTribun'));

        if (origin === 'betSlipRecommended') {
          dispatch(openModal('tribunRouteRecommendedModal', { title: response.data.status.message, isLongTermCoupon }));
        } else if (origin !== 'coupons') {
          dispatch(openModal('tribunRouteModal', { title: response.data.status.message, isLongTermCoupon }));
        } else if (origin === 'coupons') {
          dispatch(openModal('tribunShareSuccessModal', {
            couponId: coupon?.couponId || coupon?.coupon?.transactionId || coupon?.transactionId,
            selectionCount: coupon?.selectionCount || coupon?.bets?.length || coupon?.coupon?.bets?.length,
            totalOdd: coupon?.totalOdd || coupon?.coupon?.totalOdd,
          }));

          if (tabType === 'uzun-vadeli') {
            dispatch({
              type: GET_OUT_RIGHT_CONTINUE_COUPONS_SUCCESS,
              sharedCouponId: coupon.couponId
            });
          } else {
            dispatch({
              type: GET_CONTINUED_COUPONS_SUCCESS,
              sharedCouponId: coupon.couponId
            });
          }
        }
        resolve();

      }).catch(e => {
        reject(e);

        dispatch({
          type: SHARE_TRIBUN_COUPON_FAILURE,
          payload: e.response && e.response.data || errorMessage
        });
      });
    });
  }
};

export const postTribunSearch = (query, offset) => async (dispatch, getState) => {

  const tribunFeedsRequestData = {
    channel: '0',
    query: query,
    scope: 'user'
  };

  let count = 10;

  const requestBody = clone(tribunFeedsRequestData);
  const user = getState().auth.data;
  requestBody.count = +count;

  if (offset) {
    requestBody.offset = offset;
  }

  dispatch({
    type: POST_TRIBUN_SEARCH_REQUEST
  });

  axios.post(replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/search`), requestBody, { headers: { channel: '0', token: getState().tribun.userTribunToken.data } }).then(res => {
    if (!res.data.users.length) {
      return dispatch({
        type: POST_TRIBUN_SEARCH_FAILURE,
        lastPage: true
      });
    }

    dispatch({
      type: POST_TRIBUN_SEARCH_SUCCESS,
      payload: res.data,
      lastPage: res.data.users.length < count
    });

  }).catch(e => {
    dispatch({
      type: POST_TRIBUN_SEARCH_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  });
};

export const getSearchPredictions = searhText => async (dispatch, getState) => {
  try {
    const suggestionOption = {
      query: searhText,
      offset: '',
      scope: 'event',
      count: 10
    };
    dispatch({
      type: SEARCH_PREDICTIONS_REQUEST
    });

    const user = getState().auth.data;

    const res = await axios.post(replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/search`), suggestionOption, { headers: { channel: '0', token: getState().tribun.userTribunToken.data } });

    dispatch({
      type: SEARCH_PREDICTIONS_SUCCESS,
      payload: res.data
    });
  } catch (e) {
    dispatch({
      type: SEARCH_PREDICTIONS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};


export const getSearchedEventCoupon = (eventId, offset) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_SEARCHED_EVENT_COUPON_REQUEST
    });
    let appliedFilters;

    const requestBody = clone(searchedEvent);
    requestBody.offset = offset;

    if (offset) {
      requestBody.offset = offset;
    }

    const storedFilters = LocalStorage.get(FILTER_V2.appliedFiltersLocalStorageKey);
    if (storedFilters && storedFilters.search) {
      appliedFilters = storedFilters.search;
    } else {
      appliedFilters = FILTER_V2.defaultSelectedFilters;
    }
    Object.keys(appliedFilters).forEach(key => {
      requestBody[key] = appliedFilters[key];
    });

    requestBody.eventId = eventId;
    const user = getState().auth.data;

    if (LocalStorage.get('tribunHeaderSortOptions') && LocalStorage.get('tribunHeaderSortOptions').search) {
      requestBody.sortField = LocalStorage.get('tribunHeaderSortOptions').search.sortField;
      requestBody.sortOrder = LocalStorage.get('tribunHeaderSortOptions').search.sortOrder;
    }

    const res = await axios.post(replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/feed/event`),
      requestBody,
      {
        headers: {
          channel: '0'
        }
      });

    dispatch({
      type: GET_SEARCHED_EVENT_COUPON_SUCCESS,
      payload: res.data,
      count: searchedEvent.count
    });
  } catch (e) {
    dispatch({
      type: GET_SEARCHED_EVENT_COUPON_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const showOrHideCoupon = (feedId, hide, tabType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SHOW_OR_HIDE_COUOPON_REQUEST
    });

    const res = await axios.post(`${API_GATEWAY}/v2/mobile/tribun/feed/showhide`, {
      channel: '0',
      feedId: feedId,
      hide: hide
    },
    { headers: { channel: '0' } });
    dispatch({
      type: SHOW_OR_HIDE_COUOPON_SUCCESS,
      payload: res.data,
      tabType: tabType,
      feedId: feedId
    });
  } catch (e) {
    dispatch({
      type: SHOW_OR_HIDE_COUOPON_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const hideTribunFeedCoupon = (feedId, hide, tribunUserName, tabType) => async dispatch => {
  try {
    dispatch({
      type: HIDE_TRIBUN_FEED_COUPON_REQUEST
    });

    const res = await axios.post(`${API_GATEWAY}/v2/mobile/tribun/feed/personal-hide`, {
      feedId: feedId,
      hide: hide
    });

    dispatch({
      type: HIDE_TRIBUN_FEED_COUPON_SUCCESS,
      payload: res.data,
      feedId: feedId,
      hide: hide,
      tribunUserName: tribunUserName,
      tabType: tabType
    });
  } catch (e) {
    dispatch({
      type: HIDE_TRIBUN_FEED_COUPON_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
    throw e;
  }
};

export const sendComment = (feedId, text, mentions, username, userId, count, tabType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SEND_COMMENT_REQUEST
    });

    text = text.replace(/\s/gi, ' ');

    const res = await axios.post(`${API_GATEWAY}/v2/mobile/tribun/comment`, {
      feedId: feedId,
      text: text,
      mentions: mentions
    },
    { headers: { channel: '0' } });

    trackCommentTribunCoupon(feedId);

    dispatch({
      type: SEND_COMMENT_SUCCESS,
      payload: res.data,
      tabType: tabType,
      feedId: feedId
    });

    dispatch(getComment(feedId, count, tabType, '', true));

  } catch (e) {

    if ([4027, 4026].includes(e.response.data.code)) {
      dispatch({
        type: SEND_COMMENT_LIMIT_FAILURE,
        payload: e.response && e.response.data || errorMessage
      });
    } else {
      dispatch({
        type: SEND_COMMENT_FAILURE,
        payload: e.response && e.response.data || errorMessage
      });
    }
  }
};

export const deleteComment = (commentId, feedId, count, commentAuthorId, tabType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DELETE_COMMENT_REQUEST
    });

    const res = await axios.delete(`${API_GATEWAY}/v2/mobile/tribun/comment?commentid=${commentId}`,
      { headers: { channel: '0' } }
    );


    dispatch({
      type: DELETE_COMMENT_SUCCESS,
      payload: res.data,
      tabType: tabType,
      feedId: feedId
    });

    trackDeleteTribunComment(feedId, commentId, commentAuthorId);

    dispatch(getComment(feedId, count));

  } catch (e) {
    dispatch({
      type: DELETE_COMMENT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const blockUserCommenting = (userId, commentId, feedId) => async (dispatch, getState) => {

  try {

    dispatch({
      type: BLOCK_USER_REQUEST
    });

    dispatch({
      type: BLOCK_ANOTHER_USER_REQUEST
    });

    await axios.post(`${API_GATEWAY}/v2/mobile/tribun/block/by-user`,
      { userId },
      { headers: { channel: '0' } }
    );

    dispatch({
      type: BLOCK_USER_SUCCESS,
      payload: {
        userId,
        feedId,
        commentId
      }
    });

    dispatch({
      type: BLOCK_ANOTHER_USER_SUCCESS,
    });

  } catch (e) {

    dispatch({
      type: BLOCK_USER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });

    dispatch({
      type: BLOCK_ANOTHER_USER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }

};

export const unBlockUserCommenting = (userId, commentId, feedId) => async (dispatch, getState) => {
  try {

    dispatch({
      type: UNBLOCK_USER_REQUEST
    });

    dispatch({
      type: UNBLOCK_ANOTHER_USER_REQUEST
    });

    await axios.post(`${API_GATEWAY}/v2/mobile/tribun/unblock/by-user`,
      { userId },
      { headers: { channel: '0' } }
    );

    dispatch({
      type: UNBLOCK_USER_SUCCESS,
      payload: { commentId, feedId, userId }

    });

    dispatch({
      type: UNBLOCK_ANOTHER_USER_SUCCESS,
    });

  } catch (e) {

    dispatch({
      type: UNBLOCK_USER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });

    dispatch({
      type: UNBLOCK_ANOTHER_USER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }

};

export const getComment = (feedId, count, tabType, offset, isReset) => async (dispatch, getState) => {

  try {
    dispatch({
      type: GET_COMMENT_REQUEST
    });

    let url;

    if (count) {
      if (offset) {
        url = `${API_GATEWAY}/v2/mobile/tribun/comment/all?count=${ count }&feedid=${feedId}&offset=${offset}`;
      } else {
        url = `${API_GATEWAY}/v2/mobile/tribun/comment/all?count=${ count }&feedid=${feedId}`;
      }
    } else {
      url = `${API_GATEWAY}/v2/mobile/tribun/comment/all?feedid=${feedId}`;
    }

    const res = await axios.get(url,
      { headers: { channel: '0' } }
    );

    if (tabType === 'coupon-detail') {
      if (isReset) {
        dispatch({
          type: RESET_COMMENT_LIST
        });
      }
      dispatch({
        type: GET_COMMENT_LIST_SUCCESS,
        payload: { data: res.data.comments, feedId: feedId, lastPage: res.data.comments.length < count }
      });
    } else {
      dispatch({
        type: GET_COMMENT_SUCCESS,
        payload: { data: res.data.comments, feedId: feedId }
      });
    }

  } catch (e) {
    dispatch({
      type: GET_COMMENT_FAILURE,
      payload: e.response && e.response.data || errorMessage,
      lastPage: true
    });
  }
};

export const verifyTribun = (coupon, origin) => async dispatch => {
  const mapStatus = coupon.bets ? coupon.bets : coupon.selections;
  const system = coupon.systems ? coupon.systems : coupon.system;

  const payload = {
    acceptHigherOdds: true,
    acceptLowerOdds: true,
    channel: 1,
    couponCost: coupon.price,
    couponCount: 1,
    bets: [],
    expectedWinAmount: coupon.expectedWinAmount,
    multiplier: coupon.multiplier,
    source: null,
    sourceCouponId: null,
    system: system,
    totalOdd: coupon.totalOdd
  };


  const bets = mapStatus.map(bet => {
    return {
      odds: bet.odds.toString(),
      banker: bet.banker,
      mbs: bet.mbs,
      eventId: bet.eventId,
      eventVersion: bet.eventVersion,
      marketId: bet.marketId,
      marketOutcomeNo: bet.marketOutcomeNo,
      marketVersion: bet.marketVersion,
      sportType: bet.sportType,
      id: (bet.eventVersion + ':' + bet.marketId + ':' + bet.marketOutcomeNo).toString(),
      isLive: bet.isLive,
      outright: bet.outright,
      marketOutcomeName: bet.marketOutcomeName,
      eventName: bet.eventName,
      marketName: bet.marketName
    };
  });

  payload.bets = bets;
  dispatch({
    type: VERIFY_TRIBUN_REQUEST
  });

  await axios.post(`${API_GATEWAY}/iddaa/verify/tribun`, payload).then(res => {

    dispatch({
      type: VERIFY_TRIBUN_SUCCESS,
      payload: res.data
    });

  }).catch(e => {
    dispatch(closeModal('shareOnTribunModal'));
    dispatch(closeModal('couponSuccesShareOnTribun'));

    if (origin !== 'coupons') {
      dispatch(openModal('tribunCouponShareFailedModal', e.response.data));
    } else if (origin === 'coupons') {
      dispatch(openModal('couponSharePrepareFailedModal', e.response && e.response.data || errorMessage));
    }

    dispatch({
      type: VERIFY_TRIBUN_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  });

};

export const complaintTribun = (type, feedId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: COMPLAINT_TRIBUN_REQUEST
    });

    const res = await axios.post(`${API_GATEWAY}/v2/mobile/tribun/complaints`, {
      channel: '0',
      complaintItemId: feedId,
      type: type
    },
    { headers: { channel: '0' } });

    dispatch({
      type: COMPLAINT_TRIBUN_SUCCESS,
      payload: res.data
    });

    dispatch(openModal('complaintTribunSuccess'));
  } catch (e) {

    dispatch({
      type: COMPLAINT_TRIBUN_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });

    (e.response.data.code === 4011 ||  e.response.data.code === 4015 || e.response.data.code === 4012)
     && dispatch(openModal('complaintTribunFailure', { code: e.response.data.code, domain: e.response.data.domain }));
  }
};

export const commentForbidAllow = (feedId, forbid, tabType, cb) => async (dispatch, getState) => {
  try {
    dispatch({
      type: COMMENT_FORBID_ALLOW_REQUEST
    });

    const res = await axios.post(`${API_GATEWAY}/v2/mobile/tribun/comment/forbidallow`, {
      channel: '0',
      feedId: feedId,
      forbid: forbid
    },
    { headers: { channel: '0' } });

    dispatch({
      type: COMMENT_FORBID_ALLOW_SUCCESS,
      payload: res.data,
      feedId: feedId,
      tabType: tabType,
    });

    if (cb) {
      dispatch(cb(forbid));
    }
  } catch (e) {

    dispatch({
      type: COMMENT_FORBID_ALLOW_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};
export const tribunSearchUser = (query, offset) => async (dispatch, getState) => {

  const tribunFeedsRequestData = {
    channel: '0',
    query: query,
    scope: 'user'
  };

  const count = 3;

  const requestBody = clone(tribunFeedsRequestData);
  requestBody.count = count;

  dispatch({
    type: POST_TRIBUN_MENTION_SEARCH_REQUEST
  });

  axios.post(`${API_GATEWAY}/v2/mobile/tribun/search`, requestBody, { headers: { channel: '0' } }).then(res => {
    if (!res.data.users.length) {
      return dispatch({
        type: POST_TRIBUN_SEARCH_FAILURE,
        lastPage: true
      });
    }

    dispatch({
      type: POST_TRIBUN_MENTION_SEARCH_SUCCESS,
      payload: res.data,
      lastPage: res.data.users.length < count
    });

  }).catch(e => {
    dispatch({
      type: POST_TRIBUN_MENTION_SEARCH_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  });
};


export const resetSearchArea = () => dispatch => {
  dispatch({
    type: RESET_SEARCH_AREA
  });
};

export const resetSearchMatch = () => dispatch => {
  dispatch({
    type: RESET_SEARCH_MATCH
  });
};

export const resetTribunTab = () => dispatch => {
  dispatch({
    type: RESET_TRIBUN_TAB
  });
};

export const resetCommentList = () => dispatch => {
  dispatch({
    type: RESET_COMMENT_LIST
  });
};

export const spaceCouponMixPanel = (data, eventType, item, shareType) => dispatch => {
  dispatch({
    type: SPACE_COUPON_MIX_PANEL,
    payload: data,
    eventType: eventType,
    item: item,
    shareType: shareType
  });
};

export const getTribunUserAgreement = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_TRIBUN_USER_AGREEMENT_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/cms/userAgreement/latestTribuneAgreement/`);

    dispatch({
      type: GET_TRIBUN_USER_AGREEMENT_SUCCESS,
      payload: res.data
    });

    if (res.data.version) {

      await axios.post(`${API_GATEWAY}/v2/mobile/tribun/user/read-kvkk`,
        {
          channel: '0',
          version: String(res.data.version)
        },
        {
          headers: {
            channel: '0'
          }
        });
    }

  } catch (e) {

    dispatch({
      type: GET_TRIBUN_USER_AGREEMENT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getTribunTermOfUse = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_TRIBUN_TERM_OF_USE_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/cms/userAgreement/latestTribuneTermsOfUse/`);

    dispatch({
      type: GET_TRIBUN_TERM_OF_USE_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    console.log('error', e);

    dispatch({
      type: GET_TRIBUN_TERM_OF_USE_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const updateTribunCouponName = (feedId, newTitle, tabType) => async dispatch => {
  const body = {
    feedId: feedId,
    description: newTitle
  };

  try {
    dispatch({
      type: UPDATE_TRIBUN_COUPON_NAME_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/feed/change-description`,
      data: body,
      method: 'put',
      headers: {
        channel: '0'
      }
    });

    dispatch({
      type: UPDATE_TRIBUN_COUPON_NAME_SUCCESS,
      payload: res?.data,
      feedId: feedId,
      description: newTitle,
      tabType: tabType
    });

    return res?.data;

  } catch (e) {
    console.log(e);
    dispatch({
      type: UPDATE_TRIBUN_COUPON_NAME_FAILURE,
      payload: e.response?.data
    });

    return e.response?.data;
  }
};

export const deleteTribunCouponName = (feedId, tabType) => async dispatch => {
  const body = {
    feedId: feedId
  };

  try {
    dispatch({
      type: DELETE_TRIBUN_COUPON_NAME_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/feed/remove-description`,
      data: body,
      method: 'put',
      headers: {
        channel: '0'
      }
    });

    dispatch({
      type: DELETE_TRIBUN_COUPON_NAME_SUCCESS,
      payload: res?.data,
      feedId: feedId,
      tabType: tabType
    });

    return res?.data;

  } catch (e) {
    console.log(e);
    dispatch({
      type: DELETE_TRIBUN_COUPON_NAME_FAILURE,
      payload: e.response?.data
    });

    return e.response?.data;
  }
};

export const getFiltersAndSorting = tabType => async dispatch => {
  dispatch({ type: GET_FILTERS_SORTING_REQUEST });
  let filterTabs = {};
  let sortingOptions = {};
  
  const allowedTabTypes = ['search', 'match-card', 'leader', 'all', 'following', 'won'];
  
  if (!allowedTabTypes.includes(tabType)) {
    return;
  }
  
  try {
    const shouldAddContext = ['search', 'match-card'].includes(tabType);
    const url = shouldAddContext
      ? `${API_GATEWAY}/v2/mobile/tribun/filters-sort?context=${tabType}`
      : `${API_GATEWAY}/v2/mobile/tribun/filters-sort`;
    
    const response = await axios.get(url);
    
    filterTabs = response.data.filterTabs.map(tab => ({
      tabKey: tab.filterType,
      tabName: tab.tabName,
      options: tab.options || [],
      values: tab.values || [],
      minPlaceholder: tab.minPlaceholder || '',
      maxPlaceholder: tab.maxPlaceholder || '',
      unit: tab.unit || '',
      ranges: tab.ranges || [],
    }));
    
    sortingOptions = response.data.sortingOptions.map(option => ({
      value: option.label,
      sortField: option.sortField,
      sortOrder: option.sortOrder,
      rank: option.rank,
      availableInTabs: option.availableInTabs
        ? option.availableInTabs.map(tab => (tab === 'topHundred' ? 'leader' : tab))
        : undefined,
    }));
    
    dispatch({
      type: GET_FILTERS_SORTING_SUCCESS,
      payload: {
        filterTabs: filterTabs,
        sortingOptions: {
          data: sortingOptions,
          tabType: tabType,
        },
      },
    });
  } catch (error) {
    dispatch({
      type: GET_FILTERS_SORTING_FAILURE,
      payload: error.message
    });
  }
};
